import React from 'react';
import './notificationCard.style.scss';
import { __NotificationCardProps } from './notificationCard.interface';
import { ReduxState } from 'interface';
import { connect, ConnectedProps } from 'react-redux';

const NotificationCard: React.FC<ConnectedProps<typeof connector> & __NotificationCardProps> = (
    props: ConnectedProps<typeof connector> & __NotificationCardProps,
) => {
    const lang = props.lang.notification;
    const timeCal = (time: string) => {
        let diffDate = (new Date().getTime() - new Date(time).getTime()) / (1000 * 24 * 3600);
        if (diffDate >= 1) return Math.floor(diffDate) + lang.daysAgo;
        diffDate = diffDate * 24;
        if (diffDate >= 1) return Math.floor(diffDate) + lang.hoursAgo;
        diffDate = diffDate * 60;
        if (diffDate >= 1) return Math.floor(diffDate) + lang.minAgo;
        diffDate = diffDate * 60;
        if (diffDate >= 1) return Math.floor(diffDate) + lang.secAgo;
        return Math.floor(diffDate) + lang.rightNow;
    };
    return (
        <div className={`ucheck-kiosk-notif-card ${props.isNew ? 'is-new' : ''}`}>
            {props.isNew && <span className="new-box">{lang.new}</span>}
            <div className="notif-text">
                <i className="material-icons">{props.icon}</i>
                <span className="spacer" />
                <p>{props.text}</p>
            </div>
            <div>
                <i className="material-icons">schedule</i>
                <span className="spacer" />
                <div>{timeCal(props.time)}</div>
            </div>
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    lang: state.lang,
});

const connector = connect(mapStateToProps);
export default connector(NotificationCard);
